export default __webpack_public_path__ + "static/media/v_bsu.04ae2d48.jpg";